export default "__VITE_PUBLIC_ASSET__0d7f9f16__"